import React, { useEffect } from 'react';
import './IdScanPage.css';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import scanDocumentImage from './scanDocumentImage.png';

const IdScanPage = ({ onAbort }) => {
  useEffect(() => {
    // Auto-scroll to hide address bar on mobile browsers
    const hideAddressBar = () => {
      setTimeout(() => {
        window.scrollTo(0, 1);
      }, 100);
    };
    hideAddressBar();
    window.addEventListener('orientationchange', hideAddressBar);
    
    return () => {
      window.removeEventListener('orientationchange', hideAddressBar);
    };
  }, []);
  
  return (
    <div className="container idscan-container" style={{position: 'relative'}}>
      <div>
        <div className="header" style={{position: 'relative'}}>
          <IconButton
            className="back-btn"
            onClick={onAbort}
            aria-label="abort"
            size="large"
            sx={{
              position: 'absolute',
              top: 16,
              right: 16,
              background: '#fff',
              boxShadow: 1,
              zIndex: 10
            }}
          >
            <CloseIcon style={{color: '#121217'}} />
          </IconButton>
          <div className="headline">Schritt 2/3: Ausweisüberprüfung</div>
        </div>
        <div className="content-section">
          <div className="image-container">
            <img src={scanDocumentImage} alt="ID auf Scanner legen" />
          </div>
          <div className="text-block">
            <h2>Bitte die ID mit dem Foto nach unten auf den Scanner legen</h2>
            <p>Der Scan dauert ca. 5 Sekunden.</p>
          </div>
        </div>
      </div>
      <div style={{height: 72, width: '100%'}}></div>
    </div>
  );
};

export default IdScanPage;
